import React from 'react'
import Select from 'react-select'; 
import PropTypes from 'prop-types'

import selectorStyles from '../styles/selector.module.scss';
import { Grid, Calendar, Columns } from 'react-feather';


const ViewSelector = (props)  => {

    const options = [
        {value: 'day', label: 'Day'},
        {value: 'week', label: 'Week'},
        {value: 'month', label: 'Month'}
    ]

    const customStyles = {
        control: () => ({
            border: '1px solid #dddddd',
            borderRadius: '25px',
            width: '130px',
            height: '2rem',
            display: 'flex'
        }),
        option: (provided, { isFocused, isSelected }) => ({
            ...provided,
            ':active': {
                backgroundColor: '#e6e6e6'
            },
            backgroundColor: isSelected ? '#e6e6e6' : 'white',
            ':hover': {
                backgroundColor: '#e6e6e6'
            },
            cursor: 'pointer'
        })
    }

    const getIcon = (value) => {
        switch (value) {
            case 'day':
                return <Calendar size={14}/>;
            case 'week':
                return <Columns size={14}/>;
            case 'month':
                return <Grid size={14}/>;
            default: 
                return ;
        }
    }

    const formatOptionLabel = ({value, label}) => 
        <div className={selectorStyles.__option}>
            {getIcon(value)} <span className={selectorStyles.__label}>{label}</span>
        </div>

    return (
        <Select
            isSearchable={false}
            formatOptionLabel={formatOptionLabel}
            className={[selectorStyles.__selector, 'step13-calendar'].join(' ')}
            styles={customStyles}
            onChange={props.onChange}
            options={options} 
            defaultValue={options.find(o => o.value === props.defaultView)}/>
    )
}

ViewSelector.propTypes = {
    onChange: PropTypes.func.isRequired
}

export default ViewSelector

